/* eslint-disable @typescript-eslint/no-explicit-any */
import MockData from '../../components/organisms/Mgm/api-mock-data.mock'
import Api from '../../utils/api'
import {
  MULESOFT_CLIENT_ID,
  MULESOFT_CLIENT_SECRET
} from '../../utils/constants'

const MGMDashboardData = () => null

MGMDashboardData.getMGMDashboardData = async (
  url: string,
  consumerId: string,
  channel: string,
  token: string,
  platform: string,
  baseSiteId: string,
  language: string,
  isMock: boolean = false
  // eslint-disable-next-line max-params
) => {
  if (isMock) {
    return MockData
  }

  const headers = {
    'Content-Type': 'application/json',
    // TODO: Remove dummy client_id and client_secret when Mulesoft API is ready
    client_id: MULESOFT_CLIENT_ID,
    client_secret: MULESOFT_CLIENT_SECRET,
    'X-Channel': channel,
    Jwt: token // need to recheck api.ts because of reload
  }

  const API_CONSUMER_DATA = {
    url: `${url}/web/v1/api/v1/consumers/`,
    options: {
      method: 'GET',
      headers
    }
  }

  const dashboard = await Api.fetch(
    `${API_CONSUMER_DATA.url}${consumerId}/mgmDashboard?platform=${platform}&baseSiteId=${baseSiteId}&language=${language}`,
    API_CONSUMER_DATA.options
  )

  const response = await dashboard?.json()
  return response?.['response-data']
}

export default MGMDashboardData
